export const multilineSx = theme => ({
    padding: theme.spacing(2, '30px'),
    borderBottom: `2px solid ${theme.palette.grey['A700']}`,

    '&:first-of-type': { padding: theme.spacing('30px', '30px', 2) },
    '&:last-of-type': {
        padding: theme.spacing(2, '30px', '30px'),
        width: '100%',
        borderBottom: '0',
    },
});
export const labelSx = { color: 'common.black', alignItems: 'flex-start' };
export const subLabelSx = { ...labelSx, mb: '20px' };
export const inputSx = theme => ({
    width: '100%',
    maxWidth: theme.constants.tunnelInputWidth,
});
export const indentedInputsSx = { ml: '25px' };
export const option2LabelSx = { '& label': { mb: '23px' } };
export const option3LabelSx = { mb: '23px', letterSpacing: 1.6, lineHeight: 1, ml: '25px' };
export const textareaSx = {
    backgroundColor: 'background.default',
    height: 'auto',
    marginTop: '15px',
    '& > textarea': { height: 'auto' },
};
export const uploadDocSx = { marginLeft: '20px', marginBottom: '20px' };
export const uploadContainerSx = theme => ({
    ml: '20px',
    mb: '20px',
    [theme.breakpoints.down('sm')]: { mt: '10px' },
});

export const infoSx = { mt: 2, mb: '30px' };
export const optionSx = { fontSize: '16px', color: 'grey.600' };
export const radioGroupSx = { display: 'flex', flexDirection: 'row', marginBottom: '20px' };
